/* eslint no-unused-vars: "error"*/
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import { MultiStationContextProvider, useMultiStationContext } from '../Graphs/MultiStation/MultiStationContext';
import DataFilter from '@components/Graphs/MultiStation/DataFilter';
import WeatherForecast from '@components/WeatherForecast/WeatherForecast';
import { AwpContainer } from '@components/Common/AwpContainer';
import DataTableRenderer from '@components/dataTables/DataTableRenderer';
import PageActions from '@awp/components/dataTables/PageActions';
import { Views, DEFAULT_PRESET_ID_FOR_ALL_DATASETS } from '@awp/constants';
import { selectFullScreen } from '@awp/stores/fullScreenSlice';
import { Crud } from '@awp/shared/Crud';

const DataTable = () => {
  return (
    <AwpContainer fluid={true}>
      <MultiStationContextProvider isForGraph={false}>
        <DataTableWrapper />
      </MultiStationContextProvider>
    </AwpContainer>
  );
};

const DataTableWrapper = () => {
  const { weatherStations, weatherStationId, presetId, setForecastWeatherStationId, hasDeferWeatherStation } =
    useMultiStationContext();
  const navigate = useNavigate();

  const [selectedWeatherStation, setSelectedWeatherStation] = useState(null);
  const [weatherStationIndex, setWeatherStationIndex] = useState(0);
  const fullScreen = useSelector(selectFullScreen);

  const crud = new Crud('Data Tables');

  useEffect(() => {
    //when the preset changes, we need to reset the selected station and index
    setSelectedWeatherStation(null);
    setForecastWeatherStationId(null);
    if (hasDeferWeatherStation && weatherStationId > 0 && weatherStations.length > 0) {
      setWeatherStationIndex(weatherStations.findIndex((station) => station.Id === weatherStationId));
    } else {
      setWeatherStationIndex(0);
    }
  }, [presetId]);

  useEffect(() => {
    setSelectedWeatherStation(weatherStations[weatherStationIndex]);
    setForecastWeatherStationId(weatherStations[weatherStationIndex]?.Id);
  }, [weatherStations, weatherStationIndex]);

  useEffect(() => {
    if (!weatherStationId || weatherStationId === -1 || !weatherStations) return;
    if (weatherStationId > 0 && weatherStations.length > 0) {
      setWeatherStationIndex(weatherStations.findIndex((station) => station.Id === weatherStationId));
    }
  }, [weatherStationId]);

  const moveWXForward = () => {
    let wxIdx = weatherStationIndex;
    wxIdx = wxIdx + 1;
    if (wxIdx > weatherStations.length - 1) {
      wxIdx = 0;
    }
    if (!hasDeferWeatherStation && weatherStationId > 0) {
      const defWxIdx = prevDeferredStationIndex();
      if (wxIdx !== defWxIdx) {
        setWeatherStationIndex(wxIdx);
      } else {
        wxIdx = wxIdx + 1;
        if (wxIdx > weatherStations.length - 1) {
          wxIdx = 0;
        }
        setWeatherStationIndex(wxIdx);
      }
    } else {
      setWeatherStationIndex(wxIdx);
    }
  };
  const prevDeferredStationIndex = () => {
    //current is non-deferred but previous deferred station was selected
    // find the previous defered station index
    if (!hasDeferWeatherStation && weatherStationId > 0) {
      return weatherStations?.findIndex((ws) => ws.Id === weatherStationId);
    }
    return -1;
  };
  const moveWXBackward = () => {
    let wxIdx = weatherStationIndex;
    wxIdx = wxIdx - 1;
    if (wxIdx < 0) {
      wxIdx = weatherStations?.length - 1;
    }
    if (!hasDeferWeatherStation && weatherStationId > 0) {
      const defWxIdx = prevDeferredStationIndex();
      if (wxIdx !== defWxIdx) {
        setWeatherStationIndex(wxIdx);
      } else {
        wxIdx = wxIdx - 1;
        if (wxIdx < 0) {
          wxIdx = weatherStations?.length - 1;
        }
        setWeatherStationIndex(wxIdx);
      }
    } else {
      setWeatherStationIndex(wxIdx);
    }
  };

  const OpenValidationModal = () => {
    navigate(Views.ManualDataValidation, { state: { referrer: Views.DataTable } });
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className="container mt-4" style={{ position: 'relative', flex: '1' }}>
        <Row>
          <Col lg={6} md={6} sm={4}>
            {crud.getHeader()}
          </Col>
          <Col lg={6} md={6} sm={8}>
            <PageActions openValidationModal={OpenValidationModal} />
          </Col>
        </Row>
      </div>
      {!fullScreen.enabled && <DataFilter />}
      {selectedWeatherStation &&
        (presetId > 0 || presetId === DEFAULT_PRESET_ID_FOR_ALL_DATASETS) &&
        !fullScreen.enabled && (
          <WeatherForecast
            weatherStation={selectedWeatherStation}
            stationSelections={{ moveWXBackward, moveWXForward }}
            isMultiStation={true}
          />
        )}
      <DataTableRenderer />
    </div>
  );
};

export default DataTable;
